import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { ToastContainer } from 'react-toastify'
import { renderToastSuccessMsg, renderToastWarn } from 'utils/ToastUtils'
import Breadcrumb from 'component/Breadcrumb'

import ContentHeader from 'component/utils/ContentHeader'
import Grid from 'component/utils/Grid'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'

import Form from 'component/datasheetManagement/Form'
import Table from 'component/datasheetManagement/Table'
import Modal from 'component/datasheetManagement/Modal'

import * as datasheetManagementActions from 'action/datasheetManagement'
import * as datasheetFormatActions from 'action/datasheetFormat'
import * as spinnerActions from 'action/spinner'

import { MODAL_TYPE } from 'component/datasheetManagement/Modal.js'

class DatasheetManagementContainer extends PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    clearSuccessMessage: PropTypes.func.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    datasheetFormatList: PropTypes.array.isRequired,
    datasheetManagementList: PropTypes.array.isRequired,
    datasheetManagementModel: PropTypes.object,
    deleteDatasheetManagement: PropTypes.func.isRequired,
    error: PropTypes.object,
    hideSpinner: PropTypes.func.isRequired,
    listDatasheetFormat: PropTypes.func.isRequired,
    listDatasheetManagement: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    saveDatasheetManagement: PropTypes.func.isRequired,
    showSpinner: PropTypes.func.isRequired,
    success: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    getSections: PropTypes.func
  }

  constructor() {
    super()

    this.state = {
      modalType: null,
      modalItem: null,
      sectionIdNm: '',
      subSectionIdNm: '',
      typeIdNm: '',
      subTypeIdNm: '',
      editExisting: false,
      sections: { 2: [], 3: [], 4: [], 5: [] }
    }
  }

  componentDidMount() {
    const {
      auth: {
        user: { dsToken },
      },
      listDatasheetFormat,
      listDatasheetManagement,
    } = this.props

    listDatasheetFormat(dsToken)
    listDatasheetManagement(dsToken)
  }

  componentDidUpdate(prevProps) {
    const {
      clearSuccessMessage,
      error,
      success,
      translate,
      datasheetManagementModel,
      datasheetManagementList,
      auth: { user },
      getSections
    } = this.props

    if (datasheetManagementList !== prevProps.datasheetManagementList) {
      getSections(user.dsToken, datasheetManagementList, sections => this.setState({ sections }))
    }

    if (success !== prevProps.success && success) {
      if (
        datasheetManagementModel !== prevProps.datasheetManagementModel &&
        Object.getOwnPropertyNames(datasheetManagementModel).length > 0
      ) {
        this.editModal()
      } else {
        renderToastSuccessMsg(translate(success))
      }

      clearSuccessMessage()
    }

    if (error !== prevProps.error && error) {
      renderToastWarn(error)
    }
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('datasheetManagement') },
      { title: translate('datasheetManagement.formatClassification') },
    ]

    return <Breadcrumb steps={steps} />
  }

  handleSave = (values) => {
    const {
      auth: {
        user: { dsToken },
      },
      saveDatasheetManagement,
      datasheetManagementModel,
    } = this.props

    this.setState({
      sectionIdNm: values.sectionIdDescription,
      subSectionIdNm: values.subSectionIdDescription,
      typeIdNm: values.typeIdDescription,
      subTypeIdNm: values.subTypeIdDescription,
    })

    this.closeModal()

    if (datasheetManagementModel) {
      if (Object.getOwnPropertyNames(datasheetManagementModel).length > 0) {
        values.idDatasheetManagement =
          datasheetManagementModel.idDatasheetManagement
      }
    }

    const newValues = {
      idDatasheetManagement: values.idDatasheetManagement,
      sectionId: values.sectionId,
      subSectionId: values.subSectionId,
      typeId: values.typeId,
      subTypeId: values.subTypeId,
      idDatasheetFormatList: values.idDatasheetFormatList,
    }

    saveDatasheetManagement(dsToken, newValues)
  }

  openModal = (modalType, modalItem, editExisting) => {
    this.setState({ modalType, modalItem, editExisting })
  }

  editModal = () => {
    const { datasheetManagementModel } = this.props
    const { sectionIdNm, subSectionIdNm, typeIdNm, subTypeIdNm } = this.state

    this.openModal(
      MODAL_TYPE.EDIT,
      {
        ...datasheetManagementModel,
        sectionIdNm,
        subSectionIdNm,
        typeIdNm,
        subTypeIdNm,
      },
      true
    )
  }

  getPage = (page) => {
    const {
      auth: {
        user: { dsToken },
      },
      listDatasheetManagement,
    } = this.props

    listDatasheetManagement(dsToken, page)
  }

  renderModal = () => {
    const { datasheetFormatList, translate } = this.props

    const { modalType, modalItem, editExisting } = this.state

    return (
      <Modal
        closeModal={this.closeModal}
        datasheetFormatList={datasheetFormatList}
        handleDelete={this.handleDelete}
        handleSave={this.handleSave}
        initialValues={{
          idDatasheetFormatList: modalItem.datasheetFormat.map(
            (df) => df.idDatasheetFormat
          ),
        }}
        modalItem={modalItem}
        modalType={modalType}
        translate={translate}
        editExisting={editExisting}
      />
    )
  }

  handleDelete = () => {
    const {
      auth: {
        user: { dsToken },
      },
      deleteDatasheetManagement,
    } = this.props

    const { modalItem } = this.state

    this.closeModal()

    const params = {
      ...modalItem,
      idDatasheetFormatList: modalItem.datasheetFormat.map(
        (df) => df.idDatasheetFormat
      ),
    }

    deleteDatasheetManagement(dsToken, params)
  }

  closeModal = () => {
    this.setState({ modalType: null })
  }

  render() {
    const {
      auth: { user },
      count,
      current,
      datasheetFormatList,
      datasheetManagementList,
      pages,
      translate,
    } = this.props

    const { modalType, sections } = this.state

    return (
      <>
        <ContentHeader>{translate('datasheetManagement')}</ContentHeader>

        {this.renderBreadcrumb()}

        <Grid className='datasheet-management-container'>
          <h3>{translate('datasheetManagement.formatClassification')}</h3>

          <Row>
            <Form
              datasheetFormatList={datasheetFormatList}
              handleSave={this.handleSave}
              initialValues={{ idDatasheetFormatList: [] }}
              translate={translate}
              user={user}
            />
          </Row>

          {!!datasheetManagementList.length && (
            <Row>
              <Col xs={12} className='margin-top-double'>
                <Table
                  current={current}
                  datasheetManagementList={datasheetManagementList}
                  openModal={this.openModal}
                  token={user ? user.dsToken : ''}
                  translate={translate}
                  sections={sections}
                />
              </Col>
            </Row>
          )}

          {pages > 1 && (
            <Row>
              <Col xs={12} className='align-center'>
                <Pagination
                  count={count}
                  current={current}
                  getPage={this.getPage}
                  pages={pages}
                />
              </Col>
            </Row>
          )}

          {modalType ? this.renderModal() : null}

          <ToastContainer newestOnTop />
        </Grid>
      </>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = (rootReducer) => ({
  ...rootReducer.datasheetManagementReducer,
  ...rootReducer.datasheetFormatReducer,
  ...rootReducer.paginateReducer,
  ...rootReducer.spinnerReducer,
  error: rootReducer.datasheetManagementReducer.error,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...datasheetManagementActions,
      ...datasheetFormatActions,
      ...spinnerActions,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    DatasheetManagementContainer
  )
)

export { DatasheetManagementContainer }
